import { render, staticRenderFns } from "./CheckoutDesc.vue?vue&type=template&id=b1b47f58&scoped=true"
import script from "./CheckoutDesc.vue?vue&type=script&lang=js"
export * from "./CheckoutDesc.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDesc.vue?vue&type=style&index=0&id=b1b47f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b47f58",
  null
  
)

export default component.exports